"use strict";

exports.__esModule = true;
exports["default"] = {
  DATE_ROW_COUNT: 6,
  DATE_ROW_COUNT1:54,
  DATE_COL_COUNT: 7
};
module.exports = exports['default'];